import React, { useState, useEffect } from 'react';
import { Save, FileText } from 'lucide-react';
import ApiClient from '../utils/api';

const InstructionsManagement = () => {
  const [instructions, setInstructions] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadInstructions();
  }, []);

  const loadInstructions = async () => {
    try {
      const data = await ApiClient.request('/instructions');
      setInstructions(data.instructions || '');
    } catch (error) {
      console.error('Error loading instructions:', error);
    } finally {
      setLoading(false);
    }
  };

  const saveInstructions = async () => {
    setSaving(true);
    try {
      await ApiClient.request('/instructions', {
        method: 'PUT',
        body: JSON.stringify({ content: instructions })
      });
      alert('Instructions saved successfully!');
    } catch (error) {
      alert('Error saving instructions');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: '30px' }}>
        <h1 style={{ color: '#2c3e50', marginBottom: '10px' }}>📝 Agent Instructions</h1>
        <p style={{ color: '#7f8c8d' }}>Configure your agent's behavior and capabilities</p>
      </div>

      {/* Instructions Editor */}
      <div
        style={{
          background: 'white',
          padding: '25px',
          borderRadius: '12px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
          marginBottom: '30px'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}
        >
          <h3
            style={{
              margin: 0,
              color: '#2c3e50',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <FileText size={20} />
            Agent Instructions
          </h3>

          <button
            onClick={saveInstructions}
            disabled={saving}
            style={{
              background: saving
                ? '#95a5a6'
                : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '8px',
              cursor: saving ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <Save size={16} />
            {saving ? 'Saving...' : 'Save Instructions'}
          </button>
        </div>

        <textarea
          value={instructions}
          onChange={(e) => setInstructions(e.target.value)}
          placeholder="Enter your agent instructions here..."
          style={{
            width: '100%',
            minHeight: '400px',
            padding: '15px',
            border: '2px solid #e2e8f0',
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'Monaco, Consolas, "Courier New", monospace',
            lineHeight: '1.5',
            resize: 'vertical'
          }}
        />
      </div>
    </div>
  );
};

export default InstructionsManagement;
